<template>
  <ComponentLayout id="new-feature">
    <template #breadcrumbs>
      <Breadcrumbs
        class="pa-0 mb-4 "
        :items="breadcrumbs"/>
    </template>
    <template #main_content>
      <div
        class="width-100 mb-8 text-left"
        no-gutters>
        <h1 class="h1-headline">
          {{ feature.id ? $t('Releases.EditFunction') : $t('Releases.NEW_FEATURE') }}
        </h1>
      </div>
      <sForm
        ref="formNewFeature"
        class="width-100"
        label-position="top"
        label-width="100px"
        :model="feature"
        :rules="rules">
        <div
          class="form-card">
          <h2 class="h4-headline pb-3 px-0">
            {{ $t('Releases.FunctionDescription') }}
          </h2>
          <sFormItem
            :label="$t('Common.Type')"
            prop="type">
            <TypeSelect
              edit-mode
              :value.sync="feature.type"/>
          </sFormItem>
        </div>
        <div
          class="form-card">
          <h2 class="h4-headline pb-3 px-0">
            {{ $t('Releases.Ukrainian') }}
          </h2>
          <sFormItem
            :label="$t('Tenders.Nomination')"
            prop="name">
            <sInput
              clearable
              :max-length="1024"
              :max-rows="3"
              :placeholder="$t('Tenders.Nomination')"
              :rows="1"
              trim
              type="textarea"
              :value.sync="feature.name"/>
          </sFormItem>
          <sFormItem
            :label="bigFirstLetter($t('Tenders.AdditionalDescription'))"
            prop="description">
            <sInput
              clearable
              :max-length="4000"
              :max-rows="10"
              :placeholder="bigFirstLetter($t('Tenders.AdditionalDescription'))"
              :rows="5"
              trim
              type="textarea"
              :value.sync="feature.description"/>
          </sFormItem>
          <sFormItem
            :label="$t('Common.Link')"
            prop="link">
            <sInput
              clearable
              :max-length="2048"
              :placeholder="$t('Common.Link')"
              trim
              :value.sync="feature.link"/>
          </sFormItem>
        </div>
        <div
          class="form-card">
          <h2 class="h4-headline pb-3 px-0">
            {{ $t('Releases.English') }}
          </h2>
          <sFormItem
            :label="$t('Releases.Name')"
            prop="nameEng">
            <sInput
              clearable
              :max-length="1024"
              :max-rows="3"
              :placeholder="$t('Releases.Name')"
              :rows="1"
              trim
              type="textarea"
              :value.sync="feature.nameEng"/>
          </sFormItem>
          <sFormItem
            :label="$t('Releases.Description')"
            prop="descriptionEng">
            <sInput
              clearable
              :max-length="4000"
              :max-rows="10"
              :placeholder="$t('Releases.Description')"
              :rows="5"
              trim
              type="textarea"
              :value.sync="feature.descriptionEng"/>
          </sFormItem>
          <sFormItem
            :label="$t('Common.LinkEng')"
            prop="linkEng">
            <sInput
              clearable
              :max-length="2048"
              :placeholder="$t('Common.LinkEng')"
              trim
              :value.sync="feature.linkEng"/>
          </sFormItem>
        </div>
        <div
          class="form-card">
          <h2 class="h4-headline pb-3 px-0">
            {{ $t('Releases.ApproveFunctionDescription') }}
          </h2>
          <sFormItem
            label=""
            prop="isPublished">
            <sRadioGroup
              v-model="feature.isPublished"
              row>
              <sRadio :label="false">
                {{ $t('Tenders.No') }}
              </sRadio>
              <sRadio :label="true">
                {{ $t('Tenders.Yes') }}
              </sRadio>
            </sRadioGroup>
          </sFormItem>
        </div>
      </sForm>
    </template>
    <template #footer>
      <ComponentFooter
        key="footer">
        <template #back>
          <sButton
            data-qa="go-to-back"
            :to="{ name: 'create-releases' }"
            type="text">
            <sIcon
              class="s-btn-icon"
              rotate="90"
              size="10"
              type="long-arrow"/>
            {{ $t('Common.Back') }}
          </sButton>
        </template>
        <template #next>
          <sButton
            :loading="loading == 'save'"
            @click="save">
            {{ $t('Common.Save') }}
          </sButton>
        </template>
      </ComponentFooter>
    </template>
  </ComponentLayout>
</template>
<script>
import TypeSelect from 'components/releases/TypeSelect.vue'
import ComponentLayout from 'pages/templates/ComponentLayout.vue'
import Breadcrumbs from 'components/common/elements/Breadcrumbs.vue'
import ComponentFooter from 'components/common/blocks/ComponentFooter.vue'

import { mapGetters } from 'vuex'

import { modalMixin } from 'mixins'

export default {
  name: 'newFeature',
  mixins: [ modalMixin ],
  data() {
    const that = this
    return {
      rules: {
        type: [{
          type: 'string',
          required: true,
          message: that.$t('Validate.Required')
        }],
        name: [{
          type: 'string',
          required: true,
          message: that.$t('Validate.Required')
        },
        {
          type: 'string',
          required: true,
          trigger: 'exit',
          max: 245,
          message: that.$t('Validate.maxLength', {number: 245, type: that.$tc('Common.characters', 10) })
        }],
        nameEng: [{
          type: 'string',
          required: true,
          message: that.$t('Validate.Required')
        },
        {
          type: 'string',
          required: true,
          trigger: 'exit',
          max: 245,
          message: that.$t('Validate.maxLength', {number: 245, type: that.$tc('Common.characters', 10) })
        }],
        description: [
          {
            type: 'string',
            trigger: 'exit',
            max: 4000,
            message: that.$t('Validate.maxLength', {number: 4000, type: that.$tc('Common.characters', 10) })
          }],
        descriptionEng: [
          {
            type: 'string',
            trigger: 'exit',
            max: 4000,
            message: that.$t('Validate.maxLength', {number: 4000, type: that.$tc('Common.characters', 10) })
          }],
        link: [
          {
            type: 'string',
            trigger: 'change',
            transform(value) {
              return value?.trim()
            },
            max: 2048,
            message: that.$t('Validate.maxLength', {number: 4000, type: that.$tc('Common.characters', 10) })
          },
          {
            type: 'string',
            trigger: 'input',
            validator(rule, value, callback) {
              if (!value) {
                callback()
              }
              const regex = new RegExp(/^(http|https):\/\/[\w-]+(\.[\w-]+)+([\w.,@?^=%&amp;:\\/~+#-]*[\w@?^=%&amp;\\/~+#-])?$/)
              if (!regex.test(value)) {
                callback(new Error(that.$t('Validate.LinkRules')))
              }
              callback()
            },
          }
        ],
        linkEng: [
          {
            type: 'string',
            trigger: 'exit',
            max: 2048,
            message: that.$t('Validate.maxLength', {number: 4000, type: that.$tc('Common.characters', 10) })
          },
          {
            type: 'string',
            trigger: 'input',
            validator(rule, value, callback) {
              if (!value) {
                callback()
              }
              const regex = new RegExp(/^(http|https):\/\/[\w-]+(\.[\w-]+)+([\w.,@?^=%&amp;:\\/~+#-]*[\w@?^=%&amp;\\/~+#-])?$/)
              if (!regex.test(value)) {
                callback(new Error(that.$t('Validate.LinkRules')))
              }
              callback()
            },
          }
        ],
      },
      loading: false,
      feature_index: '',
      feature: {
        releaseId: '',
        name: '',
        nameEng: '',
        description: '',
        descriptionEng: '',
        link: '',
        linkEng: '' ,
        isPublished: false,
        type: '',
      },
      release: {}
      // approve: false
    }
  },
  async created() {
    this.loading = true
    this.$store.dispatch('getFeatureDetail')
    await this.$store.dispatch('getReleases')
      .then(res => {
        this.release = res?.find(el => el.id == this.$route.params.releaseId) || res[res.length - 1]
      })
    if (this.$route.params.id) {
      await this.$store.dispatch('getFeatures', {id: this.$route.params.id, releaseId: +this.$route.params.releaseId, take: 100, skip: 0})
        .then(res => {
          let feature = res.find(feat => feat.id == this.$route.params.id)
          if (feature) {
            delete feature.__typename
            this.feature = Object.assign({}, feature )
          }
        })
    }
    this.feature.releaseId = +this.$route.params.releaseId
    this.loading = false
  },
  computed: {
    ...mapGetters({
    }),
    breadcrumbs() {
      return [
        {
          text: this.release?.publishName?.length > 50 ? `${this.release?.publishName.slice(0, 47)}...` : this.release?.publishName,
          action: this.checkClose //this.$router.push({ name: 'create-releases' })
        },
        {
          text: this.feature.name,
          loading: this.loading
        },
      ]
    },
  },
  methods: {
    checkClose() {
      if ( this.feature.name || this.feature.nameEng ||
        this.feature.description || this.feature.descriptionEng ||
        this.feature.link ||  this.feature.linkEng ||
        this.feature.isPublished ||  this.feature.type ) {
        this.$root.$emit('showExitConfirmation', { submitExit: this.exit })
      } else {
        this.exit()
      }

    },
    exit() {
      this.$router.push({ name: 'create-releases' })
    },
    save() {
      this.$refs.formNewFeature.validate(async (valid) => {
        if (!valid) { return }
        this.loading = 'save'
        this.$store.dispatch( this.feature.id ? 'changeFeature' : 'createFeature', this.feature )
          .then(() => {
            this.exit()
          })
          .finally(() => this.loading = false)
      })
    }
  },
  components: {
    TypeSelect,
    Breadcrumbs,
    ComponentLayout,
    ComponentFooter,
  }
}
</script>
<style lang="scss">
#component-layout-new-feature {
  .type-chip {
    background: var(--white-color) !important;
  }
  .name-input, .description-input, .type-chip {
    width: 400px;
  }
}
.form-card {
  background-color: var(--v-main__light_green-base);
  border-color: var(--v-main__light_green-base);
  padding: 15px 20px 15px 36px;
  margin-top: 8px !important;
  border-radius: 5px;
  text-align: left;
}
</style>
